'use client';

import { useRouter } from "next/navigation";

interface ErrorStateProps {
    title?: string;
    message?: string;
    onRetry?: () => void;
}

export default function ErrorState({
    title = "خطایی رخ داد",
    message = "مشکلی پیش آمده، لطفاً دوباره تلاش کنید",
    onRetry,
}: ErrorStateProps) {
    const router = useRouter();

    const handleRetry = () => {
        if (onRetry) {
            onRetry();
        } else {
            router.refresh();
        }
    };

    return (
        <div className="flex min-h-[60vh] items-center justify-center px-4">
            <div className="max-w-md w-full rounded-2xl bg-quaternary p-6 text-center shadow-sm">

                <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-red-100">
                    <span className="text-2xl">⚠️</span>
                </div>

                <h2 className="mb-2 text-lg font-semibold text-red-300">
                    {title}
                </h2>

                <p className="mb-6 text-sm text-red-400">
                    {message}
                </p>

                <button
                    onClick={handleRetry}
                    className="inline-flex items-center justify-center rounded-xl bg-red-600 px-4 py-2 text-sm font-medium text-white transition hover:bg-red-700"
                >
                    تلاش مجدد
                </button>
            </div>
        </div>
    );
}
